import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WebformLanguage } from '@/models/web-form.model';

interface WebFormConfigState {
  previewModalVisible: boolean;
  previewModalData:
    | {
        id: string;
        language: WebformLanguage;
      }
    | undefined;
  copyModalVisible: boolean;
  copyModalData: Record<'website_url' | 'code', string> | undefined;
}

const initialState: WebFormConfigState = {
  previewModalVisible: false,
  previewModalData: undefined,
  copyModalVisible: false,
  copyModalData: undefined,
};

const webFormConfig = createSlice({
  name: 'web-form-config',
  initialState,
  reducers: {
    setPreviewModalVisible: (state, action: PayloadAction<WebFormConfigState['previewModalVisible']>) => {
      state.previewModalVisible = action.payload || initialState.previewModalVisible;
    },
    setPreviewModalData: (state, action: PayloadAction<WebFormConfigState['previewModalData']>) => {
      state.previewModalData = action.payload || initialState.previewModalData;
    },
    setCopyModalVisible: (state, action: PayloadAction<WebFormConfigState['copyModalVisible']>) => {
      state.copyModalVisible = action.payload || initialState.copyModalVisible;
    },
    setCopyModalData: (state, action: PayloadAction<WebFormConfigState['copyModalData']>) => {
      state.copyModalData = action.payload || initialState.copyModalData;
    },
  },
});

export const { setPreviewModalVisible, setPreviewModalData, setCopyModalVisible, setCopyModalData } =
  webFormConfig.actions;
export default webFormConfig.reducer;
